import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/ws',
    name: 'ws',
    component: Main,
    meta: {
      disabled: true,
      label: '物联网'
    },
    children: [
      {
        name: 'Listener',
        path: 'listener',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/WS/listener'),
        meta: {
          label: '网络监听',
        },
        children: [
        ]
      },
    ]
  }
]
